import React from "react";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import TrackingDetail from "components/TrackingDetail";
import { MONO, TEXT_DARK, BORDER, BG_TINT } from "components/bento/bentoTokens";

// Tracking detail as a modal — opened from the gallery (lightbox meta panel /
// package drawer) so staff can peek at a package's route without leaving the
// gallery. Reuses the same TrackingDetail component as the Tracking page.
const TrackingDetailDialog = ({ tracking, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={!!tracking} onClose={onClose} fullWidth maxWidth="md">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.2,
          p: "14px 20px",
          borderBottom: `1px solid ${BORDER}`,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "text.secondary" }}>
            {t("gallery.trackingDetail")}
          </Typography>
          <Typography sx={{ fontFamily: MONO, fontWeight: 800, fontSize: 17, color: TEXT_DARK }}>
            {tracking}
          </Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ ml: "auto" }} aria-label={t("common.close")}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          p: 0,
          backgroundColor: BG_TINT,
          // TrackingDetail renders its own Paper sized for the Tracking page —
          // flatten it so it fills the dialog body (same trick as scenes/tracking).
          "& > div > .MuiPaper-root": {
            maxWidth: "100%",
            borderRadius: 0,
            boxShadow: "none",
            backgroundColor: BG_TINT,
            mt: 0,
          },
        }}
      >
        {tracking && <TrackingDetail trackingNumber={tracking} />}
      </DialogContent>
    </Dialog>
  );
};

export default TrackingDetailDialog;
